import texts from './it.json';

export const getLocale = (key) => {
  return key.split('.').reduce((o, i) => o[i], texts);
};